import stableStringify from 'json-stable-stringify';
import { useMemo } from 'react';

export const useMemoValue = <T = unknown>(value: T) =>
  useMemo(
    () => value,
    // eslint-disable-next-line react-hooks/exhaustive-deps,react-hooks/use-memo
    [stableStringify(value)],
  );
